export const marginLeft = 'calc(12px + 1rem)';
